module.exports = __webpack_public_path__ + "img/404.949104dd.svg";